import React from 'react';
import { CheckIcon, CreditCardIcon, EyeIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { offerIncludes } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
import { CtaButton } from './CtaButton';
const SPOTS_TAKEN = 71;
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-20 flex-col items-center rounded-xl bg-forest-800 px-3 py-3 sm:w-24" data-id="element-98" data-mp="dg85cdiyvs1n">
      <span className="font-display text-3xl font-bold tabular-nums text-cream-50 sm:text-4xl" data-id="element-99" data-mp="ifb0n695ajwf">{value}</span>
      <span className="mt-1 text-[0.7rem] font-semibold uppercase tracking-wider text-cream-100/60" data-id="element-100" data-mp="mgo7njnz4t4x">
        {label}
      </span>
    </div>;
}
export function OfferSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23 * 3600 + 57 * 60 + 10);
  return <section id="oferta" className="w-full bg-cream-100 px-6 py-20 sm:py-24" aria-labelledby="oferta-titulo" data-id="element-101" data-mp="2t6ud70k4qxjq">
      <div className="mx-auto max-w-6xl" data-id="element-102" data-mp="2y4mh6sy1ua4a">
        <div className="mx-auto max-w-2xl text-center" data-id="element-103" data-mp="12n8mfvina0mq">
          <span className="text-sm font-semibold text-ember-500" data-id="element-104" data-mp="12otglk11rhk2">Precio de lanzamiento · Cierra en</span>
          <h2 id="oferta-titulo" className="mt-4 font-display text-3xl font-bold leading-tight text-forest-800 sm:text-4xl lg:text-[2.75rem]" data-id="element-105" data-mp="xup6wt0ecvfa">
            Tu aula puede estar lista hoy
          </h2>

          <div className="mt-8 flex justify-center gap-3" role="timer" aria-label={`Quedan ${hours} horas, ${minutes} minutos y ${seconds} segundos`} data-id="element-106" data-mp="1lm4d4wvanwvt">
            <TimeBlock value={hours} label="Horas" data-id="element-107" data-mp="1clfzw4dq60jz" />
            <TimeBlock value={minutes} label="Min" data-id="element-108" data-mp="1cjv46bfocbkj" />
            <TimeBlock value={seconds} label="Seg" data-id="element-109" data-mp="17n4qtvv97u2t" />
          </div>

          <p className="mt-5 text-base text-forest-700/70" data-id="element-110" data-mp="17oxvj5mb4486">
            Después sube. No vuelve al precio de lanzamiento.
          </p>

          <div className="mt-8 text-left" data-id="element-111" data-mp="3sckmb45f46ys">
            <div className="flex items-baseline justify-between text-sm font-semibold text-forest-700" data-id="element-112" data-mp="3sbj2aa6fca4x">
              <span data-id="element-113" data-mp="3trwqssrfuz46">Cupos al precio de lanzamiento</span>
              <span className="text-ember-500" data-id="element-114" data-mp="2mn8zodllr5n">{SPOTS_TAKEN}% tomados</span>
            </div>
            <div className="mt-2 h-2.5 w-full overflow-hidden rounded-full bg-cream-300" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={SPOTS_TAKEN} aria-label="Cupos tomados al precio de lanzamiento" data-id="element-115" data-mp="3ku2x7pl26jkp">
              <div className="h-full rounded-full bg-ember-500" style={{
              width: `${SPOTS_TAKEN}%`
            }} data-id="element-116" data-mp="3fvt2th75rn05" />
            </div>
            <p className="mt-2 text-sm text-forest-700/60" data-id="element-117" data-mp="31392spfb1vmx">Quedan pocos cupos disponibles.</p>
          </div>
        </div>

        <div className="mx-auto mt-14 max-w-3xl overflow-hidden rounded-3xl border border-cream-300 bg-white shadow-lift" data-id="element-118" data-mp="2s4nl0whnqkn7">
          <div className="flex flex-wrap items-center justify-between gap-3 bg-forest-800 px-8 py-5" data-id="element-119" data-mp="2x407vh8j3rps">
            <div data-id="element-120" data-mp="2dh5h40bx5u1u">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-ember-400" data-id="element-121" data-mp="2diqahmmhz6y4">
                Tu acceso completo
              </p>
              <h3 className="mt-1 font-display text-2xl font-bold text-cream-50" data-id="element-122" data-mp="2min5e5zhd21m">
                Kit Instrumentación Industrial Completo
              </h3>
            </div>
            <div className="flex items-center gap-2" data-id="element-123" data-mp="2ij4jp7zu4mxq">
              <span className="rounded-full bg-ember-500 px-3.5 py-1.5 text-sm font-bold text-white" data-id="element-124" data-mp="2wg17f0knpoae">
                80% OFF
              </span>
              <span className="rounded-full border border-cream-100/25 px-3.5 py-1.5 text-sm font-semibold text-cream-100" data-id="element-125" data-mp="2rflv8cc42mu0">
                Más elegido
              </span>
            </div>
          </div>

          <div className="px-8 py-9" data-id="element-126" data-mp="319vodw8vnp5s">
            <p className="text-base text-forest-700/60" data-id="element-127" data-mp="3f6iyl0pucbtn">
              Precio normal: <span className="line-through" data-id="element-128" data-mp="3a87qauf729dj">$97 USD</span>
            </p>
            <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-ember-500" data-id="element-129" data-mp="3a64o7c0ropsg">
              Precio de lanzamiento
            </p>
            <p className="mt-2 font-display text-6xl font-bold text-forest-800" data-id="element-130" data-mp="1dhldjuc5k10w">
              $19 <span className="text-2xl font-semibold text-forest-700/60" data-id="element-131" data-mp="1i93j6vp4eps7">USD</span>
            </p>

            <p className="mt-4 flex items-center gap-2 text-sm text-forest-700/60" data-id="element-132" data-mp="1ma6vx9bvg5p7">
              <EyeIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="pk5zqp96amxv" />
              14 docentes viendo esto ahora
            </p>

            <CtaButton className="mt-7 w-full sm:w-auto" source="oferta" data-id="element-134" data-mp="uir1it42peof" />

            <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm text-forest-700/70" data-id="element-135" data-mp="ykudrjykgnar">
              <li className="flex items-center gap-1.5" data-id="element-136" data-mp="yn74ommay7zy">
                <ZapIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-137" data-mp="13kqi5kb6egqu" /> Acceso inmediato
              </li>
              <li className="flex items-center gap-1.5" data-id="element-138" data-mp="29zris3b5bn3r">
                <CreditCardIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-139" data-mp="2eyb5w71h74xp" /> Pago único
              </li>
              <li className="flex items-center gap-1.5" data-id="element-140" data-mp="2p1pvvpta5uzq">
                <ShieldCheckIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-141" data-mp="2k47vintbwo3c" /> Garantía 7 días
              </li>
              <li className="flex items-center gap-1.5" data-id="element-142" data-mp="2fcg285isg49i">
                <LockIcon className="h-4 w-4 text-forest-400" aria-hidden="true" data-id="element-143" data-mp="2fava0mjy4xet" /> Pago seguro
              </li>
            </ul>

            <ul className="mt-9 grid gap-3 border-t border-cream-200 pt-8 sm:grid-cols-2" data-id="element-144" data-mp="26d2txg6ehlqd">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[0.95rem] leading-snug text-forest-700/85" data-id="element-145" data-mp="21bvlrg0cikj6">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-600" strokeWidth={3} aria-hidden="true" data-id="element-146" data-mp="1wgg9gshzkwov" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl rounded-2xl border border-cream-300 bg-cream-50 p-8" data-id="element-147" data-mp="3mqt6zcfhzkc5">
          <h3 className="font-display text-2xl font-semibold text-forest-800" data-id="element-148" data-mp="1k4e696fjva2i">Por qué hoy es el momento</h3>
          <p className="mt-4 text-base leading-relaxed text-forest-700/75" data-id="element-149" data-mp="1ove2sakrbq4h">
            Hoy recibís los 6 volúmenes técnicos (360 páginas) + los 5 bonos de implementación (150 páginas) a
            precio de lanzamiento. Después de esta ventana, el precio sube a $97 USD.
          </p>
          <p className="mt-3 text-base font-semibold text-ember-600" data-id="element-150" data-mp="22uvje2nwfx2r">
            71% de los cupos ya se tomaron. Solo quedan 29 accesos al precio de lanzamiento.
          </p>
        </div>
      </div>
    </section>;
}